import vitaziLogoWhite from '@/assets/images/01_Vitazi.ai logo_dark_blue_Transparent.png';

export function ReportFooter() {
  return (
    <div className="mt-auto">
      <div className="w-full h-10 bg-[#152644] flex items-center justify-center px-4">
        <img src={vitaziLogoWhite} alt="Vitazi.ai" className="h-6 object-contain" />
      </div>
    </div>
  );
}
